import { memo, useId, useMemo } from "react";

import { Accordion } from "@/components/ui/accordion/accordion";

import { FilterAccordionItem } from "./components/FilterAccordionItem";
import { SALE_STATUS } from "./constants";
import { useFilterCheckboxState } from "./hooks/useFilterCheckboxState";

import type { FilterInSaleAndStopSellingProps } from "../../type";

export const FilterInSaleAndStopSellingForLaptop = memo(
	({
		isPending,
		itemsName,
		selectedItemIDs,
		onChangeSelectedItemIDs,
		inSaleItems,
		stopSellingItems,
	}: FilterInSaleAndStopSellingProps) => {
		const uniqueIdForStopSellingItems = useId();
		const uniqueIdForInSaleItems = useId();

		const isInSaleItemsExist = useMemo(() => inSaleItems.length > 0, [inSaleItems]);
		const isStopSellingItemsExist = useMemo(() => stopSellingItems.length > 0, [stopSellingItems]);
		const isEitherInSaleItemsOrStopSellingItemsExist = useMemo(
			() => isInSaleItemsExist || isStopSellingItemsExist,
			[isInSaleItemsExist, isStopSellingItemsExist],
		);

		const {
			addedSelectAllItemSelectedIDs,
			addedSelectAllInSaleItems,
			addedSelectAllStopSellingItems,
			handleCheckboxChange,
		} = useFilterCheckboxState({
			itemsName,
			selectedItemIDs,
			onChangeSelectedItemIDs,
			inSaleItems,
			stopSellingItems,
		});

		if (!isEitherInSaleItemsOrStopSellingItemsExist) {
			return null;
		}

		return (
			<div>
				<h5 className="font-semibold">表示する{itemsName}</h5>
				<div className="mx-4">
					<Accordion type="multiple">
						{isInSaleItemsExist && (
							<FilterAccordionItem
								uniqueId={uniqueIdForInSaleItems}
								label={SALE_STATUS(itemsName).IN_SALE.LABEL}
								items={addedSelectAllInSaleItems}
								selectedItemIDs={addedSelectAllItemSelectedIDs}
								isPending={isPending}
								onCheckedChange={handleCheckboxChange}
							/>
						)}

						{isStopSellingItemsExist && (
							<FilterAccordionItem
								uniqueId={uniqueIdForStopSellingItems}
								label={SALE_STATUS(itemsName).STOP_SELLING.LABEL}
								items={addedSelectAllStopSellingItems}
								selectedItemIDs={addedSelectAllItemSelectedIDs}
								isPending={isPending}
								onCheckedChange={handleCheckboxChange}
							/>
						)}
					</Accordion>
				</div>
			</div>
		);
	},
);

FilterInSaleAndStopSellingForLaptop.displayName = "FilterInSaleAndStopSellingForLaptop";
